import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkLink } from 'uitk-react-link';
import { UitkSecondaryButton } from 'uitk-react-button';

const LinkTrack = ClickTracker(UitkLink);

export interface ChatBotCardProps {
  dialogTitle: string;
  cardHeader: string;
  cardContent: string;
  launchBot: () => void;
}

export const ChatBotCard: React.FunctionComponent<ChatBotCardProps> = ({ dialogTitle, cardHeader, cardContent, launchBot }) => (
  <div className="all-t-padding-six all-x-padding-three all-y-padding-one" data-stid="chat-bot-card">
    <div className="uitk-flex uitk-flex-wrap uitk-flex-gap-two uitk-flex-align-items-center">
      <div className="uitk-type-heading-600 uitk-flex-grow-1">{cardHeader}</div>
      <div className="uitk-flex-grow-10">{cardContent}</div>
      <div>
        <LinkTrack linkName="launch chatbot" rfrr="HIS.VRCHATBOT.LAUNCH" theme="primary" inline={true} onClick={launchBot}>
          <UitkSecondaryButton text={dialogTitle} />
        </LinkTrack>
      </div>
    </div>
  </div>
);
ChatBotCard.displayName = 'ChatBotCard';
